import { createFileRoute } from '@tanstack/react-router';
import { Register } from '../../organisms/Register';
import z from 'zod';

const registerSearchSchema = z.object({
  code: z.string().optional(),
  state: z.union([z.string(), z.object()]).optional(),
  email: z.string().optional(),
  step: z.enum(['options', 'details']).optional().catch(undefined),
});

export const Route = createFileRoute('/_unauthenticated/register')({
  component: Register,
  validateSearch: (search) => registerSearchSchema.parse(search),
});
